import {
  masterBreakPoint,
  maxWidth400,
  maxWidth950Landscape,
} from "./breakpoints"

const globalFontRules = {
  fontFamily: ["Poppins Regular"],
  fontStyle: "normal",
  htmlFontSize: 14,
  fontWeight: 300,
}

const typography = ({
  fontFamily = "Poppins Regular",
  fontSize = "18px",
} = {}) => {
  const fontSizeNumber = parseInt(fontSize?.replace("px", ""), 10)
  const baseFont = Array.isArray(fontFamily)
    ? fontFamily[0]
    : fontFamily || "Poppins Regular"
  const boldFontFamily = baseFont.replace("Regular", "Bold")
  return {
    ...globalFontRules,
    fontFamily: [baseFont],
    primary: {
      fontSize: fontSizeNumber,
      lineHeight: "1.4285em",
      fontFamily: [fontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 2,
      },
    },
    primaryBold: {
      fontSize: fontSizeNumber,
      lineHeight: "1.4285em",
      fontFamily: [boldFontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 2,
      },
    },
    span: {
      fontSize: fontSizeNumber,
      lineHeight: "1.4285em",
      fontFamily: [fontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 8,
      },
    },
    title: {
      fontSize: fontSizeNumber + 6,
      fontFamily: [fontFamily],
      fontWeight: 700,
      lineHeight: "1.4285em",
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber + 2,
      },
    },
    h2: {
      fontSize: fontSizeNumber + 9.429,
      color: "#555",
      fontFamily: [fontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 2,
      },
    },
    h3: {
      fontSize: fontSizeNumber + 2.571,
      lineHeight: "1.28571429em",
      fontWeight: 700,
      fontFamily: [fontFamily],
    },
    h6: {
      fontSize: fontSizeNumber,
      fontFamily: [fontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 2,
      },
    },
    div: {
      // fontSize: "1.15rem",
      fontSize: fontSizeNumber + 0.4,
      fontFamily: [fontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: "1rem",
      },
    },
    button: {
      fontSize: fontSizeNumber - 4,
      fontFamily: [fontFamily],
      [`${maxWidth400}`]: {
        fontSize: fontSizeNumber - 7,
      },
    },
    body: {
      fontSize: fontSizeNumber - 6,
      fontFamily: [fontFamily],
      [`${maxWidth950Landscape}`]: {
        fontSize: fontSizeNumber - 7,
      },
    },
    bodyBold: {
      fontSize: fontSizeNumber - 6,
      fontFamily: [boldFontFamily],
      fontWeight: "normal",
    },
    body1: {
      whiteSpace: "break-spaces",
      fontSize: fontSizeNumber - 4,
      fontFamily: [fontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 6,
      },
    },
    body2: {
      fontSize: fontSizeNumber - 4,
      fontFamily: [fontFamily],
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 6,
      },
      [`${maxWidth950Landscape}`]: {
        fontSize: fontSizeNumber - 6,
      },
    },
    body2Bold: {
      fontFamily: [boldFontFamily],
      fontWeight: "normal",
      fontSize: fontSizeNumber - 4,
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 6,
      },
    },
    body3: {
      fontSize: fontSizeNumber - 2,
      fontFamily: [fontFamily],
      [`${maxWidth950Landscape}`]: {
        fontSize: fontSizeNumber - 5,
      },
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 4,
      },
    },
    body3Bold: {
      fontSize: fontSizeNumber - 2,
      fontFamily: [boldFontFamily],
      fontWeight: "normal",
      [`${maxWidth950Landscape}`]: {
        fontSize: fontSizeNumber - 5,
      },
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber - 4,
      },
    },
    bodySmall: {
      fontSize: fontSizeNumber - 8,
      fontFamily: [fontFamily],
    },
    caption: {
      fontSize: fontSizeNumber - 6,
      fontFamily: [fontFamily],
      [`${maxWidth950Landscape}`]: {
        fontSize: fontSizeNumber - 8,
      },
    },
    titleBold: {
      fontSize: fontSizeNumber + 6,
      fontFamily: [boldFontFamily],
      fontWeight: 700,
      lineHeight: "1.4285em",
      [`${masterBreakPoint}`]: {
        fontSize: fontSizeNumber + 2,
      },
    },
  }
}

export { globalFontRules, typography }
